export default [
  {
    path: '/subscriptions',
    name: 'subscriptions',
    component: () => import('@/pages/subscriptions/SubscriptionList'),
    meta: {
      requiresAuth: true,
    },
  },
];
